export default __webpack_public_path__ + "static/media/accomm_img_1.ff5ec7c5.PNG";